// File: config.navbar.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration used by cgp-nav-bar.
// Other Contributors:

import { baseConfig } from './config.base';

// Nav Bar Items
const ctwr = {
    id: 'CTWR',
    title: 'CTWR',
    iconClass: 'fa fa-fw fa-list-alt',
    expanded: true,
    children: [
        {
            id: 'CTWR/Administration',
            title: 'Administration',
            iconClass: 'fa fa-fw',
            children: [
                {
                    id: 'CTWR/Administration',
                    title: 'Security',
                    iconClass: 'fa fa-fw',
                    children: [
                        {
                            id: 'CTWR/Administration/Users',
                            title: 'Users',
                            iconClass: 'fa fa-fw',
                        },
                        {
                            id: 'CTWR/Administration/Roles',
                            title: 'Roles',
                            iconClass: 'fa fa-fw',
                        }

                    ]
                },
                {
                    id: 'CTWR/Administration/',
                    title: 'Maintenance',
                    iconClass: 'fa fa-fw',
                    children: [
                        {
                            id: 'CTWR/Administration/Parts',
                            title: 'Parts',
                            iconClass: 'fa fa-fw'
                        },
                        {
                            id: 'CTWR/Administration/Part-types',
                            title: 'Part Types',
                            iconClass: 'fa fa-fw'
                        },
                        {
                            id: 'CTWR/Administration/Part-families',
                            title: 'Part Families',
                            iconClass: 'fa fa-fw'
                        },
                        {
                            id: 'CTWR/Administration/Processes',
                            title: 'Processes',
                            iconClass: 'fa fa-fw'
                        },
                        {
                            id: 'CTWR/Administration/Categories',
                            title: 'Categories',
                            iconClass: 'fa fa-fw'
                        },
                        {
                            id: 'CTWR/Administration/Item-Names',
                            title: 'Item Names',
                            iconClass: 'fa fa-fw'
                        },
                        {
                            id: 'CTWR/Administration/Item-Descriptions',
                            title: 'Item Descriptions',
                            iconClass: 'fa fa-fw'
                        },
                        {
                            id: 'CTWR/Administration/Locations',
                            title: 'Locations',
                            iconClass: 'fa fa-fw'
                        },
                        {
                            id: 'CTWR/Administration/Programs',
                            title: 'Programs',
                            iconClass: 'fa fa-fw'
                        },
                        {
                            id: 'CTWR/Administration/Design-phases',
                            title: 'Design Phases',
                            iconClass: 'fa fa-fw'
                        },
                        // {
                        //     id: 'CTWR/Administration/Escalations',
                        //     title: 'Escalations',
                        //     iconClass: 'fa fa-fw'
                        // },
                        {
                            id: 'CTWR/Administration/Notifications',
                            title: 'Notifications',
                            iconClass: 'fa fa-fw'
                        }
                    ]
                }
            ]

        },
        {
            id: 'CTWR/Requests',
            title: 'Requests',
            iconClass: 'fa fa-fw',
        }
    ]
}

export const navItems = [ctwr];

// Nav Bar Actions
//
export const navActions = {};